module.exports = __webpack_public_path__ + "static/img/jamk.52714cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/jamk.png
// module id = pK2M
// module chunks = 1